import i18next from 'i18next';

i18next.addResources('es', 'projects-iirsa', {
  code: 'Código',
  name: 'Nombre',
  stage: 'Etapa',
  theme: 'Tema',
  subtheme: 'Subtema',
  countries: 'Países',
  unidentified: 'Sin identificar',
  territory: 'Territorio',
  projects: 'Proyectos y Acciones',
  charts: 'Gráficos',
  territories: 'Territorios',
  projectsMin: 'Proyectos y Acciones (mín.)',
  projectsMax: 'Proyectos y Acciones (máx.)',
  description: 'Descripción',
  start: 'Inicio',
  analytics: 'Analíticas',
  exportGoal: 'Objetivo',
  exportScope: 'Ámbito',
  exportProjectType: 'Tipo',
  exportEndDate: 'Fecha de Finalización',
  exportSource: 'Fuente',
  exportResponsibles: 'Responsables',
  exportTerm: 'Plazo',
});

i18next.addResources('en', 'projects-iirsa', {
  code: 'Code',
  name: 'Name',
  stage: 'Stage',
  theme: 'Theme',
  subtheme: 'Subtheme',
  countries: 'Countries',
  unidentified: 'Unidentified',
  territory: 'Territory',
  projects: 'Projects and Actions',
  charts: 'Charts',
  territories: 'Territories',
  projectsMin: 'Projects and Actions (min.)',
  projectsMax: 'Projects and Actions (max.)',
  description: 'Description',
  start: 'Home',
  analytics: 'Analytics',
  exportGoal: 'Goal',
  exportScope: 'Scope',
  exportProjectType: 'Type',
  exportEndDate: 'End date',
  exportSource: 'Source',
  exportResponsibles: 'Responsible parties',
  exportTerm: 'Term',
});

i18next.addResources('pt', 'projects-iirsa', {
  code: 'Código',
  name: 'Nome',
  stage: 'Etapa',
  theme: 'Tema',
  subtheme: 'Subtema',
  countries: 'Países',
  unidentified: 'Não identificado',
  territory: 'Território',
  projects: 'Projetos e Ações',
  charts: 'Gráficos',
  territories: 'Territórios',
  projectsMin: 'Projetos e Ações (mín.)',
  projectsMax: 'Projetos e Ações (máx.)',
  description: 'Descrição',
  start: 'Início',
  analytics: 'Analíticas',
  exportGoal: 'Objetivo',
  exportScope: 'Âmbito',
  exportProjectType: 'Tipo',
  exportEndDate: 'Data de conclusão',
  exportSource: 'Fonte',
  exportResponsibles: 'Responsáveis',
  exportTerm: 'Prazo',
});
